import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-unit-deatil',
    templateUrl: './breadcrumb.unit.detail.component.html'
})

export class BreadcrumbUnitDetailComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() facilityId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
